(function(){
  // Shared constants
  const ERROR_CLASS = 'field-has-error';
  const ERROR_TEXT_REQUIRED = 'Please fill out this field.';
  // Shared name validation (used by register + address)
  const ERROR_TEXT_FIRST_NAME = 'Please enter a valid name using letters, spaces, and hyphens only, the character length must be atleast 3';
  const ERROR_TEXT_LAST_NAME  = 'Please enter a valid name using letters, spaces, and hyphens only';

  // Registration-specific
  const ERROR_TEXT_EMAIL = 'Please enter a valid email address.';
  const ERROR_TEXT_PASSWORD = 'Passwords must contain at least 8 characters, including uppercase, lowercase letters, numbers and special characters.';
  // Address-specific
  const ERROR_TEXT_ADDRESS1 = 'Please enter a valid street address.';
  const ERROR_TEXT_CITY     = 'Please enter a valid city name (letters, spaces only).';
  const ERROR_TEXT_ZIP      = 'Only numbers allowed.';
  const ERROR_TEXT_PHONE    = 'Only digits, plus sign, hyphen, and letter \'x\' are allowed.';

  // Validators (shared + specific)
  function isNameValid(v){ return /^[A-Za-z][A-Za-z\s'-]*$/.test((v||'').trim()); }
  function isEmailValid(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v||'').trim()); }
  function isPasswordValid(v){ return /[A-Z]/.test(v)&&/[a-z]/.test(v)&&/[0-9]/.test(v)&&/[^A-Za-z0-9]/.test(v)&&v.length>=8; }
  function isAddress1Valid(v){ return (v||'').trim().length >= 5; }
  function isCityValid(v){ return /^[A-Za-z][A-Za-z\s'-]*$/.test((v||'').trim()); }
  function isZipValid(v){ return /^[0-9]+$/.test((v||'').trim()); }
  function isPhoneValid(v){
    const cleaned = (v||'').trim();
    if(!cleaned) return false;
    if(/[^0-9+\-xX\s]/.test(cleaned)) return false;
    const digits = cleaned.replace(/\D+/g,'');
    return digits.length >= 7;
  }

  // Error helpers
  function removeError(field){
    field.classList.remove(ERROR_CLASS);
    const id = field.id;
    if(id){
      field.removeAttribute('aria-describedby');
      const old = document.getElementById('err_'+id);
      if(old) old.remove();
    }
    const sib = field.nextElementSibling;
    if(sib && sib.classList.contains('field-error')) sib.remove();
  }
  function showError(field,msg){
    if(field.classList.contains(ERROR_CLASS)) return;
    field.classList.add(ERROR_CLASS);
    const id = field.id || '';
    const span = document.createElement('span');
    span.className='field-error';
    span.style.cssText='color:#c00;font-size:12px;display:block;margin-top:4px;';
    span.setAttribute('role','alert');
    span.textContent=msg;
    if(id){
      span.id='err_'+id;
      field.setAttribute('aria-describedby',span.id);
    }
    field.insertAdjacentElement('afterend',span);
  }

  // Core field validation dispatcher
  function validateField(field){
    removeError(field);
    const raw = field.value || '';
    const val = raw.trim();
    if(!val){
      showError(field, ERROR_TEXT_REQUIRED);
      return false;
    }
    const type = field.dataset.validate;

    // Shared name rules
    if(type === 'first-name'){
      if(val.length < 3 || !isNameValid(val)){
        showError(field, ERROR_TEXT_FIRST_NAME);
        return false;
      }
    } else if(type === 'last-name'){
      if(val.length < 3 || !isNameValid(val)){
        showError(field, ERROR_TEXT_LAST_NAME);
        return false;
      }
    }
    // Registration-specific
    else if(type === 'email'){
      if(!isEmailValid(val)){ showError(field, ERROR_TEXT_EMAIL); return false; }
    } else if(type === 'password'){
      if(!isPasswordValid(raw)){ showError(field, ERROR_TEXT_PASSWORD); return false; }
    }
    // Address-specific
    else if(type === 'address1'){
      if(!isAddress1Valid(val)){ showError(field, ERROR_TEXT_ADDRESS1); return false; }
    } else if(type === 'city'){
      if(!isCityValid(val)){ showError(field, ERROR_TEXT_CITY); return false; }
    } else if(type === 'zip'){
      if(!isZipValid(val)){ showError(field, ERROR_TEXT_ZIP); return false; }
    } else if(type === 'phone'){
      if(!isPhoneValid(val)){ showError(field, ERROR_TEXT_PHONE); return false; }
    }

    // Legacy zip detection (if no data-validate but name contains [zip])
    if(!type && field.name && field.name.indexOf('[zip]')>-1){
      if(!isZipValid(val)){ showError(field, ERROR_TEXT_ZIP); return false; }
    }
    return true;
  }

  function validateForm(form){
    const fields=[...form.querySelectorAll('.js-required')];
    let firstInvalid=null;
    let ok=true;
    fields.forEach(f=>{
      if(!validateField(f)){
        ok=false;
        if(!firstInvalid) firstInvalid=f;
      }
    });
    if(firstInvalid) firstInvalid.focus();
    return ok;
  }

  function attachListeners(){
    document.addEventListener('submit', e=>{
      const form=e.target;
      if(!(form.classList.contains('js-address-form')
        || form.classList.contains('js-login-form')
        || form.classList.contains('js-reset-form')
        || form.classList.contains('js-register-form'))) return;
      if(!validateForm(form)){
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    document.addEventListener('blur', e=>{
      const field=e.target;
      if(field.classList && field.classList.contains('js-required')){
        validateField(field);
      }
    }, true);

    document.addEventListener('input', e=>{
      const field=e.target;
      if(field.classList && field.classList.contains('js-required') && field.classList.contains(ERROR_CLASS)){
        validateField(field);
      }
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }
})();